export default __webpack_public_path__ + "static/media/name_icon.0cd7c8f4.svg";